export default [
  {
    // 统计信息
    path: 'statisticalInfo',
    name: 'statisticalInfo',
    component: statisticalInfo => require(['../components/statisticalInfo/statisticalInfo'], statisticalInfo),
    children:[
      {
        // 统计信息主页
        path:'statisticalInfoMain',
        name:'statisticalInfoMain',
        component: statisticalInfoMain => require(['../components/statisticalInfo/statisticalInfoMain'], statisticalInfoMain),
      },
    ]
  },
  {
    // 需求记录
    path: 'demandRecord',
    name: 'demandRecord',
    component: demandRecord => require(['../components/demandRecord/demandRecord'], demandRecord),
    children:[
      {
        // 需求记录主页
        path:'demandRecordMain',
        name:'demandRecordMain',
        component: demandRecordMain => require(['../components/demandRecord/demandRecordMain'], demandRecordMain),
        meta: {
          keepAlive: true, //此组件需要被缓存
          isBack:false, //用于判断上一个页面是哪个
        },
      },
    ]
  },
  {
    // 内容管理
    path: 'contentManagement',
    name: 'contentManagement',
    component: contentManagement => require(['../components/contentManagement/contentManagement'], contentManagement),
    // children:[
    //   {
    //     // banner管理
    //     path: 'bannerManage',
    //     name: 'bannerManage',
    //     component: bannerManage => require(['../components/contentManagement/bannerManage'], bannerManage),
    //   },
    //   {
    //     // 服务管理
    //     path: 'serviceManage',
    //     name: 'serviceManage',
    //     component: serviceManage => require(['../components/contentManagement/serviceManage'], serviceManage),
    //   },
    // ]
  },
  {
    // 案例管理
    path: 'caseManagement',
    name: 'caseManagement',
    component: caseManagement => require(['../components/caseManagement/caseManagement'], caseManagement),
    children:[
      {
        // 案例管理主页
        path:'caseManagementMain',
        name:'caseManagementMain',
        component: caseManagementMain => require(['../components/caseManagement/caseManagementMain'], caseManagementMain),
        // meta: {
        //   keepAlive: true, //此组件需要被缓存
        //   isBack:false, //用于判断上一个页面是哪个
        // },
      },
      {
        //表格详情
        path: 'tableDetail',
        name: 'tableDetail',
        component:tableDetail => require(['../components/caseManagement/tableDetail'], tableDetail),
      }
    ]
  },
  {
    // 线上服务
    path: 'onlineService',
    name: 'onlineService',
    component: onlineService => require(['../components/onlineService/onlineService'], onlineService),
    children:[
      {
        // 客户留言
        path: 'customerMessage',
        name: 'customerMessage',
        component: customerMessage => require(['../components/onlineService/customerMessage'], customerMessage),
      },
      {
        // 客户报修
        path: 'customerRepair',
        name: 'customerRepair',
        component: customerRepair => require(['../components/onlineService/customerRepair'], customerRepair),
      },
    ]
  },
  {
    // 信息管理
    path: 'infoManagement',
    name: 'infoManagement',
    component: infoManagement => require(['../components/infoManagement/infoManagement'], infoManagement),
    children:[
      {
        // 方案配置
        path: 'schemeConfig',
        name: 'schemeConfig',
        component: schemeConfig => require(['../components/infoManagement/schemeConfig'], schemeConfig),
      },
    ]
  },
  {
    // 用户管理
    path: 'userManagement',
    name: 'userManagement',
    component: userManagement => require(['../components/userManagement/userManagement'], userManagement),
    children:[
      {
        // 客户管理
        path: 'CustomerManage',
        name: 'CustomerManage',
        component: CustomerManage => require(['../components/userManagement/CustomerManage'], CustomerManage),
      },
      {
        // 职员管理
        path: 'staffMemberManage',
        name: 'staffMemberManage',
        component: staffMemberManage => require(['../components/userManagement/staffMemberManage'], staffMemberManage),
      },
    ]
  },
  {
    // 个人资料
    path: 'personalData',
    name: 'personalData',
    component: personalData => require(['../components/personalSetting/personalSettingMain'], personalData),
  },
]



// WEBPACK FOOTER //
// ./src/router/twoLevelRouter.js